"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addRole = addRole;
exports.controlRoleStatus = controlRoleStatus;
exports.delRole = delRole;
exports.deletePaymentMode = deletePaymentMode;
exports.getInfo = getInfo;
exports.getPayShowType = getPayShowType;
exports.getPaymentModeInfo = getPaymentModeInfo;
exports.getPaymentModeList = getPaymentModeList;
exports.getRoleList = getRoleList;
exports.menuCacheList = menuCacheList;
exports.savePaymentMode = savePaymentMode;
exports.updateRole = updateRole;
exports.updateRoleStatus = updateRoleStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 新增
 * @param 
 */
function addRole(pram) {
  // data.rules = pram.rules.join(',')
  return (0, _request.default)({
    url: '/admin/system/role/saveRole',
    method: 'POST',
    data: pram
  });
}

/**
 * 删除
 * @param 
 */
function delRole(pram) {
  return (0, _request.default)({
    url: '/admin/system/role/deleteRole',
    method: 'post',
    data: pram
  });
}

/**
 * 详情
 * @param 
 */
function getInfo(pram) {
  return (0, _request.default)({
    url: "/admin/system/getRoleDetail",
    method: 'GET',
    params: pram
  });
}

/**
 * 分页列表
 * @param 
 */
function getRoleList(pram) {
  var data = {
    createTime: pram.createTime,
    updateTime: pram.updateTime,
    level: pram.level,
    page: pram.page,
    limit: pram.limit,
    roleName: pram.roleName,
    rules: pram.rules,
    status: pram.status
  };
  return (0, _request.default)({
    url: '/admin/system/role/getRoleList',
    method: 'get',
    params: data
  });
}

/**
 * 修改
 * @param 
 */
function updateRole(pram) {
  return (0, _request.default)({
    url: '/admin/system/role/update',
    method: 'post',
    data: pram
  });
}

/**
 * 修改身份状态
 * @param 
 */
function updateRoleStatus(pram) {
  return (0, _request.default)({
    url: '/admin/system/role/updateStatus',
    method: 'get',
    params: {
      id: pram.id,
      status: pram.status
    }
  });
}

/**
 * 缓存菜单
 * @param 
 */
function menuCacheList(pram) {
  return (0, _request.default)({
    url: '/admin/system/menu/getMenuList',
    method: 'get'
  });
}

// 获取支付方式列表
function getPaymentModeList(params) {
  return (0, _request.default)({
    url: '/admin/system/getPaymentModeList',
    method: 'get',
    params: params
  });
}

// 删除支付方式
function deletePaymentMode(pram) {
  return (0, _request.default)({
    url: '/admin/system/deletePaymentMode',
    method: 'post',
    data: pram
  });
}

// 获取支付方式详情
function getPaymentModeInfo(pram) {
  return (0, _request.default)({
    url: '/admin/system/getPaymentModeInfo',
    method: 'get',
    params: pram
  });
}

// 保存支付方式
function savePaymentMode(pram) {
  return (0, _request.default)({
    url: '/admin/system/savePaymentMode',
    method: 'post',
    data: pram
  });
}

// 控制角色启用状态
function controlRoleStatus(pram) {
  return (0, _request.default)({
    url: '/admin/system/role/controlRoleStatus',
    method: 'post',
    data: pram
  });
}

// 获取支付方式展示方式
function getPayShowType(pram) {
  return (0, _request.default)({
    url: '/admin/system/getPayShowType',
    method: 'get',
    params: pram
  });
}